// extracted by mini-css-extract-plugin
export default {"rules":"styles-module__rules____6UcC","ok":"styles-module__ok___TjfKi"};